<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">


        <!--Resolve claim - Dialog-->
        <v-dialog
                persistent
                v-model="resolveClaimDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Resolve Claim</span>
                </v-card-title>

                <v-card-text>

                    <v-flex xs12 md12 pl-4 pa-2>
                        <FakeItem v-show="getInitialLoading">
                        </FakeItem>

                        <v-form
                                ref="form"
                                v-model="valid"
                                lazy-validation
                        >

                            <v-textarea
                                    :rules="[rules.length(20)]"
                                    required
                                    auto-grow
                                    rows="4"
                                    label="Resolve Remark"
                                    v-model="resolveRemark"
                                    counter
                                    maxlength="500"
                            ></v-textarea>

                        </v-form>

                    </v-flex>


                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat
                           @click.native="openCloseResolveDialog(null)">CANCEL
                    </v-btn>
                    <v-btn color="primary darken-1" flat
                           @click.native="resolveClaim()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Received Supplier Order Position</v-toolbar-title>
            <v-toolbar-title v-else>Edit Received Supplier Order Position - {{selectedItem.id}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>RECEIVED POSITION</v-tab>
                <v-tab :disabled="noClaims">CLAIMS</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">Received Supplier Order Position
                                        <v-spacer></v-spacer>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Received Position</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Product Reference"
                                                    v-model="selectedItem.reference"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>

                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Manufacturer"
                                                    v-model="selectedItem.manufacturer.name"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Quantity"
                                                    v-model="selectedItem.quantity"
                                                    type="number"
                                                    min="1"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Unit Net Weight"
                                                    v-model="selectedItem.net_weight"
                                                    type="number"
                                                    min="1"
                                                    readonly
                                                    suffix="kg"
                                            ></v-text-field>
                                        </v-flex>


                                        <!--                                    <v-flex xs12 md4 pl-4 pa-2>
                                                                                <FakeItem v-show="getInitialLoading">
                                                                                </FakeItem>
                                                                                <v-autocomplete
                                                                                        v-show="!getInitialLoading"
                                                                                        clearable
                                                                                        :items="getUnits"
                                                                                        label="Unit"
                                                                                        v-model="selectedItem.units_id"
                                                                                        item-value="id"
                                                                                        item-text="name"
                                                                                ></v-autocomplete>
                                                                            </v-flex>-->


                                        <!--                              <v-flex xs12 md6 pl-4 pa-2>
                                                                          <FakeItem v-show="getInitialLoading">
                                                                          </FakeItem>
                                                                          <v-text-field
                                                                                  v-show="!getInitialLoading"
                                                                                  suffix="kg"
                                                                                  label="Net Weight"
                                                                                  v-model="selectedItem.product.weight"
                                                                                  type="number"
                                                                                  step=".01"
                                                                                  min="0"
                                                                                  readonly
                                                                          ></v-text-field>
                                                                      </v-flex>-->

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker v-show="!getInitialLoading"
                                                            locale="de-DE"
                                                            landscape
                                                            mysql
                                                            :width="width = 500"
                                                            label="Received Date"
                                                            v-model="selectedItem.created_at"
                                                            format="DD.MM.YYYY"
                                                            dateOnly
                                            >
                                            </DatetimePicker>

                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-textarea
                                                    v-show="!getInitialLoading"
                                                    auto-grow
                                                    rows="4"
                                                    label="Remark"
                                                    v-model="selectedItem.remark"
                                                    counter
                                                    maxlength="500"
                                                    readonly
                                            ></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Packaging List</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <VueGallery id="packagingListIndex" :images="packagingListImageLinks"
                                                    :index="packagingListIndex"
                                                    @close="packagingListIndex = null"></VueGallery>
                                        <div class="carouselor">
                                            <v-card
                                                    class="image"
                                                    v-for="(image, imageIndex) in packagingListImageLinks"
                                                    :key="imageIndex+100000"
                                                    @click="packagingListIndex = imageIndex+100000"
                                                    :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                            ></v-card>
                                        </div>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product Label / Serial number</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <VueGallery id="productLabelIndex" :images="productLabelImageLinks"
                                                    :index="productLabelIndex"
                                                    @close="productLabelIndex = null"></VueGallery>
                                        <div class="carouselor">
                                            <v-card
                                                    class="image"
                                                    v-for="(image, imageIndex) in productLabelImageLinks"
                                                    :key="imageIndex+200000"
                                                    @click="productLabelIndex = imageIndex+200000"
                                                    :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                            ></v-card>
                                        </div>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product Pictures</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <VueGallery id="productIndex" :images="productImageLinks"
                                                    :index="productIndex"
                                                    @close="productIndex = null"></VueGallery>
                                        <div class="carouselor">
                                            <v-card
                                                    class="image"
                                                    v-for="(image, imageIndex) in productImageLinks"
                                                    :key="imageIndex+300000"
                                                    @click="productIndex = imageIndex+300000"
                                                    :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                            ></v-card>
                                        </div>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Packaging Pictures</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <VueGallery id="packageIndex" :images="packageImageLinks"
                                                    :index="packageIndex"
                                                    @close="packageIndex = null"></VueGallery>
                                        <div class="carouselor">
                                            <v-card
                                                    class="image"
                                                    v-for="(image, imageIndex) in packageImageLinks"
                                                    :key="imageIndex+400000"
                                                    @click="packageIndex = imageIndex+400000"
                                                    :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                            ></v-card>
                                        </div>

                                    </v-card-title>

                                    <v-card-actions>
                                        <!--                           <v-layout mt-2 pb-3 pr-3>
                                                                       <v-spacer></v-spacer>
                                                                       <v-btn :loading="saveProcess" color="secondary"
                                                                              @click.native="saveSupplierOrderPosition()">
                                                                           Save
                                                                           <v-icon class="white&#45;&#45;text" right>save</v-icon>
                                                                       </v-btn>
                                                                   </v-layout>-->
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>

            <v-tab-item>
                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">Received Supplier Order Position Claims
                                        <v-spacer></v-spacer>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Claims</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-container class="claimItem"
                                                     v-for="(item, index) in selectedItem.suppliers_orders_positions_received_claims"
                                                     :key="index+600000"
                                        >
                                            <v-layout wrap>

                                                <v-flex xs12 pr-3 pl-3>
                                                    <v-layout wrap>
                                                        <v-subheader>Claim</v-subheader>
                                                        <v-spacer></v-spacer>
                                                        <v-btn :loading="resolvingClaim === item.id" :disabled="item.resolved" icon color="secondary darken-1"
                                                               @click.native="openCloseResolveDialog(item.id)">
                                                            <v-icon>check</v-icon>
                                                        </v-btn>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>


                                                <v-flex xs12 md12 pl-4 pa-2>
                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>
                                                    <v-textarea
                                                            v-show="!getInitialLoading && item.resolved"
                                                            auto-grow
                                                            rows="4"
                                                            label="Resolved Remark"
                                                            v-model="item.resolved_remark"
                                                            counter
                                                            maxlength="500"
                                                            readonly

                                                    ></v-textarea>
                                                </v-flex>

                                                <v-flex xs12 md6 pl-4 pa-2>
                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>

                                                    <v-text-field
                                                            v-show="!getInitialLoading"
                                                            label="Type"
                                                            v-model="item.suppliers_orders_positions_received_claim_type.name"
                                                            readonly
                                                    ></v-text-field>
                                                </v-flex>


                                                <v-flex xs12 md2 pl-4 pa-2>
                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>
                                                    <v-text-field
                                                            v-show="!getInitialLoading"
                                                            label="Quantity"
                                                            v-model="item.quantity"
                                                            type="number"
                                                            min="1"
                                                            readonly
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md4 pl-4 pa-2>
                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>
                                                    <DatetimePicker v-show="!getInitialLoading"
                                                                    locale="de-DE"
                                                                    landscape
                                                                    mysql
                                                                    :width="width = 500"
                                                                    label="Claim Date"
                                                                    v-model="item.created_at"
                                                                    format="DD.MM.YYYY"
                                                                    dateOnly
                                                    >
                                                    </DatetimePicker>

                                                </v-flex>

                                                <v-flex xs12 md12 pl-4 pa-2>
                                                    <FakeItem v-show="getInitialLoading">
                                                    </FakeItem>
                                                    <v-textarea
                                                            v-show="!getInitialLoading"
                                                            auto-grow
                                                            rows="4"
                                                            label="Remark"
                                                            v-model="item.remark"
                                                            counter
                                                            maxlength="500"
                                                            readonly
                                                    ></v-textarea>
                                                </v-flex>

                                                <v-flex xs12 pr-3 pl-3>
                                                    <v-subheader>Claim Pictures</v-subheader>
                                                    <v-divider></v-divider>
                                                </v-flex>

                                                <VueGallery id="claimIndex" :images="claimImageLinks[index]"
                                                            :index="claimIndex"
                                                            @close="claimIndex = null"></VueGallery>
                                                <div class="carouselor">
                                                    <v-card
                                                            class="image"
                                                            v-for="(image, imageIndex) in claimImageLinks[index]"
                                                            :key="imageIndex+600000"
                                                            @click="claimIndex = imageIndex+500000"
                                                            :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                                    ></v-card>
                                                </div>
                                            </v-layout>
                                            <v-flex xs12 pr-3 pl-3>
                                                <v-divider></v-divider>
                                            </v-flex>

                                        </v-container>

                                    </v-card-title>
                                    <v-card-actions>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
        </v-tabs-items>


    </v-card>

</template>

<script>
    import {API_URL} from '../../../store/index'

    import {
        Settings,
        SupplierOrder,
        SupplierOrderPosition,
        SupplierOrderPositionReceived,
        Documents
    } from '../../../store/namespace-helper'
    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import FakeItem from '../../Shared/FakeItem.vue'
    import FakeTable from '../../Shared/FakeTable.vue'
    import ProcessHistory from '../../Shared/ProcessHistory.vue'
    import WarehouseReceived from '../SupplierOrderPositions/WarehouseReceived.vue'

    import {dateFunctionFilters} from '../../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../../mixins/initialLoadingMixin'
    import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'

    import VueGallery from 'vue-gallery'

    import {VMoney} from 'v-money'

    /*   import _ from 'lodash' */

    export default {
      components: {
        DatetimePicker,
        FakeItem,
        FakeTable,
        ProcessHistory,
        WarehouseReceived,
        VueGallery
      },
      name: 'add-supplier-order-position',
      mixins: [dateFunctionFilters, initialLoadingMixin, comboAutoCompleteFiltersMixin],
      data () {
        return {
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          touchless: true,
          saveProcess: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: true /* doesn't work with directive */
          },
          discountTypes: ['percent'],
          unitPrice: null,
          packagingListImageLinks: [],
          packagingListIndex: null,
          productLabelImageLinks: [],
          productLabelIndex: null,
          productImageLinks: [],
          productIndex: null,
          packageImageLinks: [],
          packageIndex: null,
          claimImageLinks: [],
          claimIndex: null,
          resolveClaimDialog: false,
          resolvingClaim: null,
          resolveClaimId: null,
          valid: true,
          rules: {
            email: v => (v || '').match(/@/) || 'Please enter a valid email',
            length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
            password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
                        'Password must contain an upper case letter, a numeric character, and a special character',
            required: v => !!v || 'This field is required'
          },
          resolveRemark: null

        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.initialLoadingTimeout(850)
              this.loadUnits()
              this.initUnitSalesPrice()
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(SupplierOrderPositionReceived.actions.setSelectedSupplierOrderPositionReceived, null)
          this.$store.dispatch(SupplierOrderPositionReceived.actions.openCloseDialog)
          this.activeTab = 0
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
            /*        saveSupplierOrderPosition () {
                      let supplierOrderPosition = {
                        id: this.selectedItem.id,
                        quantity: this.selectedItem.quantity,
                        unit_purchase_price: this.unit_purchase_price,
                        units_id: this.selectedItem.units_id,
                        est_receiving_date: this.selectedItem.est_receiving_date
                      }

                      this.$store.dispatch(SupplierOrderPosition.actions.saveSupplierOrderPosition, supplierOrderPosition)
                    }, */
        initUnitSalesPrice () {
          var element = document.getElementById('unitPrice')
          var event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(this.selectedItem.unit_purchase_price)
            element.dispatchEvent(event)
          }
        },
        resolveClaim () {
          if (!this.$refs.form.validate()) {
            return
          }
          let resolveClaim = {
            id: this.resolveClaimId,
            resolved: true,
            resolved_remark: this.resolveRemark
          }
          this.resolvingClaim = this.resolveClaimId

          this.$store.dispatch(SupplierOrderPositionReceived.actions.saveSupplierOrderPositionReceivedClaim, resolveClaim).then(response => {
            this.resolvingClaim = null
          }).catch(reason => {
            this.resolvingClaim = null
          })

          this.openCloseResolveDialog(null)
        },
        openCloseResolveDialog (id) {
          this.resolveClaimId = id
          this.$refs.form.reset()
          this.resolveClaimDialog = !this.resolveClaimDialog
          return this.resolveClaimDialog
        }
      },
      computed: {
        selectedItem () {
          return this.$store.getters[SupplierOrderPositionReceived.getters.getSelectedSupplierOrderPositionReceived]
        },
        selectedSupplierOrder () {
          return this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder]
        },
        getPackagingListImages () {
          if (this.selectedItem.suppliers_orders_positions_received_pictures) {
            return this.selectedItem.suppliers_orders_positions_received_pictures.filter(picture => picture.suppliers_orders_positions_received_pictures_types_id === 1)
          } else {
            return []
          }
        },
        getPackagingProductLabelImages () {
          if (this.selectedItem.suppliers_orders_positions_received_pictures) {
            return this.selectedItem.suppliers_orders_positions_received_pictures.filter(picture => picture.suppliers_orders_positions_received_pictures_types_id === 2)
          } else {
            return []
          }
        },
        getProductImages () {
          if (this.selectedItem.suppliers_orders_positions_received_pictures) {
            return this.selectedItem.suppliers_orders_positions_received_pictures.filter(picture => picture.suppliers_orders_positions_received_pictures_types_id === 3)
          } else {
            return []
          }
        },
        getPackageImages () {
          if (this.selectedItem.suppliers_orders_positions_received_pictures) {
            return this.selectedItem.suppliers_orders_positions_received_pictures.filter(picture => picture.suppliers_orders_positions_received_pictures_types_id === 4)
          } else {
            return []
          }
        },
        getClaimImages () {
          if (this.selectedItem.suppliers_orders_positions_received_claims) {
            return this.selectedItem.suppliers_orders_positions_received_claims
          } else {
            return []
          }
        },
        noClaims () {
          if (this.selectedItem.suppliers_orders_positions_received_claims) {
            return (this.selectedItem.suppliers_orders_positions_received_claims.length <= 0)
          }
          return true
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].id === 0
        }
      },
      watch: {
        getPackagingListImages: {
          handler (val) {
            let vm = this
            this.packagingListImageLinks = []
            val.forEach(function (obj, index) {
              vm.$store.dispatch(Documents.actions.getDocumentToken, {
                id: obj.documents_id,
                filename: 'packagingListImage_' + obj.suppliers_orders_positions_received_id + '_' + (index + 1)
              }).then(response => {
                var link = API_URL + '/documentStore/' + response.data.data.token
                vm.packagingListImageLinks.push(link)
              }).catch(reason => {
                console.log('could not get docuement token:' + reason)
              })
            })
          },
          deep: true
        },
        getPackagingProductLabelImages: {
          handler (val) {
            let vm = this
            this.productLabelImageLinks = []
            val.forEach(function (obj, index) {
              vm.$store.dispatch(Documents.actions.getDocumentToken, {
                id: obj.documents_id,
                filename: 'productLabelImage_' + obj.suppliers_orders_positions_received_id + '_' + (index + 1)
              }).then(response => {
                var link = API_URL + '/documentStore/' + response.data.data.token
                vm.productLabelImageLinks.push(link)
              }).catch(reason => {
                console.log('could not get docuement token:' + reason)
              })
            })
          },
          deep: true
        },
        getProductImages: {
          handler (val) {
            let vm = this
            this.productImageLinks = []
            val.forEach(function (obj, index) {
              vm.$store.dispatch(Documents.actions.getDocumentToken, {
                id: obj.documents_id,
                filename: 'productLabelImage_' + obj.suppliers_orders_positions_received_id + '_' + (index + 1)
              }).then(response => {
                var link = API_URL + '/documentStore/' + response.data.data.token
                vm.productImageLinks.push(link)
              }).catch(reason => {
                console.log('could not get docuement token:' + reason)
              })
            })
          },
          deep: true
        },
        getPackageImages: {
          handler (val) {
            let vm = this
            this.packageImageLinks = []
            val.forEach(function (obj, index) {
              vm.$store.dispatch(Documents.actions.getDocumentToken, {
                id: obj.documents_id,
                filename: 'productLabelImage_' + obj.suppliers_orders_positions_received_id + '_' + (index + 1)
              }).then(response => {
                var link = API_URL + '/documentStore/' + response.data.data.token
                vm.packageImageLinks.push(link)
              }).catch(reason => {
                console.log('could not get docuement token:' + reason)
              })
            })
          },
          deep: true
        },
        getClaimImages: {
          handler (val) {
            let vm = this
            this.claimImageLinks = []
            if (val) {
              val.forEach(function (item, claimsIndex) {
                var tempImageLinks = []
                if (item.suppliers_orders_positions_received_claims_pictures) {
                  item.suppliers_orders_positions_received_claims_pictures.forEach(function (obj, index) {
                    vm.$store.dispatch(Documents.actions.getDocumentToken, {
                      id: obj.documents_id,
                      filename: 'claimImage_' + obj.suppliers_orders_positions_received_claims_id + '_' + (index + 1)
                    }).then(response => {
                      var link = API_URL + '/documentStore/' + response.data.data.token
                      tempImageLinks.push(link)
                    }).catch(reason => {
                      console.log('could not get docuement token:' + reason)
                    })
                  })
                }
                vm.claimImageLinks.push(tempImageLinks)
              })
            }
          },
          deep: true
        }
      },
      directives: {money: VMoney}
    }
</script>

<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .process-history {
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

    .carouselor {
        overflow-x: scroll;
        overflow-y: hidden;
        height: auto;
        white-space: nowrap
    }

    .carouselor .image {
        /*  float: left;*/
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 8px;
        display: inline-block;
    }


</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrderPositions/AddWarehouseOrderPosition.vue